/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import React from 'react';
import { ITaskCreationFlowProps } from '../ModifyServices.Model';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import theme from '../../../../../../Shared/Themes/theme';
import { buttonStyles } from '../../../../../Jobs/Components/UpdateShiftDate/UpdateShiftDate.Style';
import Button, { ButtonType } from '../../../../../../Shared/Components/Common/Buttons/Button';
import { useTranslation } from 'react-i18next';

const TaskSourceSelector: React.FC<ITaskCreationFlowProps> = ({ selectedOption, setNextClick, handleOptionChange }) => {
  const { radioButton, radioButtonText } = buttonStyles;
  const { t } = useTranslation(['taskManagement']);

  return (
    <>
      <FormControl component="fieldset">
        <Typography
          sx={{
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.h3?.fontSize,
            fontWeight: theme.typography.fontWeightBold,
          }}>
          {t('taskManagement:HowWouldYouLikeToAddTasks')}
        </Typography>
        <RadioGroup value={selectedOption} onChange={handleOptionChange}>
          <Box sx={{ marginLeft: '1rem', marginTop: '1rem' }}>
            <FormControlLabel
              value="select-existing-task"
              control={
                <Radio
                  sx={{
                    ...radioButton,
                  }}
                />
              }
              label={t('taskManagement:ChooseFromExistingTasks')}
              sx={{
                ...radioButtonText,
              }}
            />
          </Box>
          <Box sx={{ marginLeft: '1rem', marginTop: '1rem' }}>
            <FormControlLabel
              value="create-new-task"
              control={
                <Radio
                  sx={{
                    ...radioButton,
                  }}
                />
              }
              label={t('taskManagement:CreateANewTask')}
              sx={{
                ...radioButtonText,
              }}
            />
          </Box>
        </RadioGroup>
      </FormControl>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem', gap: 2 }}>
        <Button type={ButtonType.Primary} label={t('taskManagement:Next')} onClick={() => setNextClick(true)} />
      </Box>
    </>
  );
};

export default TaskSourceSelector;
